export default function Services() {
  return <div className="services-shell">
    <section className="section wrap" id="services">
      <div className="section-head">
        <div>
          <p className="eyebrow">Services</p>
          <h2>What do you need to build?</h2>
        </div>
        <p className="section-intro">Bring me a new idea, an existing product, or a technical problem that needs a fresh look.</p>
      </div>
      <div className="grid">
        <article className="service">
          <span className="icon" aria-hidden="true">&lt;/&gt;</span>
          <div className="service-body">
            <h3>Web applications</h3>
            <p>Take your product from a first prototype to a working app, with the frontend and backend built together.</p>
            <small>React · Next.js · Node.js</small>
          </div>
        </article>
        <article className="service">
          <span className="icon" aria-hidden="true">↔</span>
          <div className="service-body">
            <h3>Backends &amp; integrations</h3>
            <p>Connect your product to the data, payments, and external services it needs to work.</p>
            <small>REST APIs · Express · AWS Lambda</small>
          </div>
        </article>
        <article className="service">
          <span className="icon" aria-hidden="true">↑</span>
          <div className="service-body">
            <h3>Cloud &amp; deployment</h3>
            <p>Set up hosting and automated deployments so releasing updates takes fewer manual steps.</p>
            <small>AWS · Docker · GitHub Actions</small>
          </div>
        </article>
        <article className="service">
          <span className="icon" aria-hidden="true">▯</span>
          <div className="service-body">
            <h3>Mobile applications</h3>
            <p>Bring your product to iOS and Android with a shared codebase and an experience designed for mobile.</p>
            <small>React Native · TypeScript</small>
          </div>
        </article>
        <article className="service">
          <span className="icon" aria-hidden="true">✳</span>
          <div className="service-body">
            <h3>AI &amp; workflow automation</h3>
            <p>Reduce repetitive work with LLM features and automation connected to your existing tools.</p>
            <small>LLM integrations · Python · APIs</small>
          </div>
        </article>
        <article className="service">
          <span className="icon" aria-hidden="true">≡</span>
          <div className="service-body">
            <h3>Databases &amp; data systems</h3>
            <p>Give your app a solid data foundation with schemas and queries designed around how it’s used.</p>
            <small>PostgreSQL · Supabase · SQL</small>
          </div>
        </article>
        <article className="service consulting">
          <span className="icon" aria-hidden="true">⌁</span>
          <div className="service-body">
            <h3>Need a second set of eyes?</h3>
            <p>Architecture reviews, code audits, and technical planning before your next big decision.</p>
          </div>
          <a href="#contact">Let’s talk consulting <span aria-hidden="true">↗</span>
          </a>
        </article>
      </div>
    </section>
  </div>;
}
